(async function (window, document) {
  let buttonEls = document.getElementsByClassName('embedded-pay-button');
  let iframeLoading = false;
  let host = '';
  let loaderEl = null;

  function init() {
    let modalEl = createModalEl();
    loaderEl = createLoaderEl();

    for (let i = 0; i < buttonEls.length; i++) {
      let buttonEl = buttonEls[i];
      const dataHost = buttonEl.getAttribute('data-host');
      const url = new URL(dataHost);
      url.searchParams.set('embedded', 'true');
      url.searchParams.set('parentUrl', window.location.href);
      host = url.toString();

      buttonEl.addEventListener('click', () => {
        buttonEl.disabled = true;
        show(loaderEl);

        // Create a new iframe every time
        let contentEl = modalEl.getElementsByClassName('modal-content')[0];
        // Clear any existing iframe
        contentEl.innerHTML = '';

        let iframeEl = createIframe();
        loadIframe(iframeEl, modalEl, function () {
          hide(loaderEl);
          show(modalEl);
          buttonEl.disabled = false;
        });
      });
    }

    // receive message from child window
    window.addEventListener(
      'message',
      function (e) {
        // Don't listen to messages from other origins
        if (e.origin !== new URL(host).origin) return;

        let key = e.message ? 'message' : 'data';
        let data = e[key];
        if (data && data.action && data.action === 'closeModal') {
          hide(modalEl);
          iframeLoading = false;
        }
      },
      false,
    );
  }

  function createModalEl() {
    return createEl(
      'div',
      {
        className: 'embedded-pay-modal',
        innerHTML: "<div class='modal-content'></div>",
      },
      document.body,
    );
  }

  function createLoaderEl() {
    return createEl('div', { className: 'embedded-pay-loader' }, document.body);
  }

  function createIframe() {
    return createEl('iframe', {
      id: 'embedded-pay-embedded-widget',
      style: { width: '100%', minHeight: '100%' },
      allow: 'payment',
      loading: 'eager',
    });
  }

  function loadIframe(iframeEl, modalEl, callback) {
    if (iframeLoading) return;

    iframeLoading = true;
    show(loaderEl);

    // Set load event first before changing src
    iframeEl.onload = function () {
      iframeLoaded = true;
      hide(loaderEl);
      // Add a small delay to ensure loader is fully hidden before showing modal
      setTimeout(() => {
        callback();
        iframeEl.contentWindow.focus();
      }, 50);
    };

    // Add to DOM before setting src for faster loading
    let contentEl = modalEl.getElementsByClassName('modal-content')[0];
    contentEl.appendChild(iframeEl);
    iframeEl.setAttribute('src', host);
  }

  function show(el) {
    if (el) {
      el.style.display = 'block';
      // Trigger reflow to ensure transition works
      el.offsetHeight;
      if (el.classList.contains('embedded-pay-modal')) {
        el.classList.add('show');
      }
    }
  }

  function hide(el) {
    if (el) {
      if (el.classList.contains('embedded-pay-modal')) {
        el.classList.remove('show');
        // Wait for transition to complete before hiding
        setTimeout(() => {
          el.style.display = 'none';
        }, 300);
      } else {
        el.style.display = 'none';
      }
    }
  }

  function createEl(type, attributes, parent) {
    const el = document.createElement(type);

    Object.entries(attributes).forEach(([key, value]) => {
      if (key === 'style') {
        Object.entries(value).forEach(([styleKey, styleValue]) => {
          el.style[styleKey] = styleValue;
        });
      } else {
        el[key] = value;
      }
    });

    if (parent) {
      parent.appendChild(el);
    }

    return el;
  }

  function domReady(callback) {
    if (document.readyState !== 'loading') {
      callback();
    } else if (document.addEventListener) {
      document.addEventListener('DOMContentLoaded', callback);
      document.addEventListener('readystatechange', callback);
    } else {
      window.attachEvent('onload', callback);
    }
  }

  domReady(init);
})(window, document);
